module.exports = __webpack_public_path__ + "static/img/logo.6c408e80.svg";